import { BrandLockup } from "../components/common/BrandLockup";
import { Footer } from "../components/common/Footer";

export function InstitutionalPage() {
  return (
    <>
      <nav className="nav">
        <BrandLockup />
        <div className="nav-divider" />
        <ul className="nav-links">
          <li><a href="#produtos">Produtos</a></li>
          <li><a href="#verticais">Verticais</a></li>
          <li><a href="#empresa">Empresa</a></li>
          <li><a href="#cultura">Cultura</a></li>
        </ul>
        <div className="nav-right">
          <a href="/go/login" className="nav-ghost">Entrar</a>
          <a href="/go" className="nav-btn">Fale com a THH</a>
        </div>
      </nav>

      <div className="hero">
        <div className="hero-bg-line" />
        <div className="hero-grid-accent">
          <div className="mockup-wrap f5">
            <div className="mockup-label">THH GO — painel ao vivo</div>
            <div className="app-shell">
              <div className="app-titlebar">
                <div className="tbar-dot" style={{ background: "#ff5f57" }} />
                <div className="tbar-dot" style={{ background: "#febc2e" }} />
                <div className="tbar-dot" style={{ background: "#28c840" }} />
              </div>
              <div className="app-body">
                <div className="app-sidebar">
                  <div className="sb-icon active">
                    <svg viewBox="0 0 14 14" aria-hidden="true"><rect x="1" y="1" width="12" height="12" rx="2" /><path d="M1 5h12M5 1v4M9 1v4" /></svg>
                  </div>
                  <div className="sb-icon">
                    <svg viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="5" r="3" /><path d="M1 13c0-3 2.7-5 6-5s6 2 6 5" /></svg>
                  </div>
                  <div className="sb-icon">
                    <svg viewBox="0 0 14 14" aria-hidden="true"><polyline points="1,10 4,7 7,9 13,3" /></svg>
                  </div>
                </div>
                <div className="app-main">
                  <div className="day-header">
                    <span className="day-title">Abril 17 · Quinta</span>
                    <span className="day-sub">8 agendados</span>
                  </div>
                  <div className="slot-row">
                    <span className="slot-time">09h</span>
                    <div className="slot-evt blue"><div className="evt-name">Mariana Costa</div><div className="evt-info">Corte + escova · 60min</div></div>
                  </div>
                  <div className="slot-row">
                    <span className="slot-time">10h</span>
                    <div className="slot-evt navy"><div className="evt-name">Juliana Ramos</div><div className="evt-info">Coloração · 90min</div></div>
                  </div>
                  <div className="slot-row">
                    <span className="slot-time">11h</span>
                    <div className="slot-evt blue"><div className="evt-name">Fernanda Lima</div><div className="evt-info">Hidratação · 45min</div></div>
                  </div>
                  <div className="slot-row">
                    <span className="slot-time">12h</span>
                    <div className="slot-evt empty"><div className="evt-name">Disponível</div></div>
                  </div>
                  <div className="stat-strip">
                    <div className="s-card"><div className="s-lbl">Receita</div><div className="s-val">R$920</div><div className="s-delta">+12%</div></div>
                    <div className="s-card"><div className="s-lbl">Atend.</div><div className="s-val">8</div><div className="s-delta">hoje</div></div>
                    <div className="s-card"><div className="s-lbl">Retorno</div><div className="s-val">74%</div><div className="s-delta">30d</div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-left">
          <div className="hero-kicker f1"><span className="hero-kicker-dot"></span>Plataforma operacional</div>
          <h1 className="hero-h1 f2">THH liga<br />seu <em>negócio.</em></h1>
          <p className="hero-sub f3">Software para organizar a operação, reduzir atrito e preparar empresas para crescer com mais eficiência e consistência.</p>
          <div className="hero-actions f4">
            <a href="/go" className="btn-hero">Conheça os produtos</a>
            <a href="/go/start" className="hero-link">Fale com a THH <span className="hero-link-arrow">→</span></a>
          </div>
        </div>

        <div className="scroll-cue">
          <div className="scroll-line" />
          Scroll
        </div>
      </div>

      <div className="stat-bar">
        <div className="stat-bar-item"><div className="sb-num">01<span>.</span></div><div className="sb-lbl">Vertical de entrada em validação</div></div>
        <div className="stat-bar-item"><div className="sb-num">04<span>.</span></div><div className="sb-lbl">Verticais mapeadas para expansão</div></div>
        <div className="stat-bar-item"><div className="sb-num">∞<span>.</span></div><div className="sb-lbl">Base única, sem refazer a arquitetura</div></div>
        <div className="stat-bar-item"><div className="sb-num">0<span>.</span></div><div className="sb-lbl">Complexidade desnecessária ao usuário</div></div>
      </div>

      <section className="sec">
        <div className="sec-kicker">Como geramos valor</div>
        <h2 className="sec-h">Menos improviso.<br />Mais operação.</h2>
        <p className="sec-sub">A THH resolve dores reais do dia a dia para que o negócio possa crescer sem perder o controle da operação.</p>
        <div className="valor-layout">
          <div className="valor-col"><div className="valor-n">01</div><div className="valor-t">Organiza a operação</div><div className="valor-d">Mais clareza para a rotina do negócio. Agenda, equipe e serviços em um único lugar.</div></div>
          <div className="valor-col-rule" />
          <div className="valor-col"><div className="valor-n">02</div><div className="valor-t">Reduz trabalho manual</div><div className="valor-d">Menos atrito e dependência de improviso. Confirmações, lembretes e avaliação pós-atendimento trabalham no mesmo fluxo.</div></div>
          <div className="valor-col-rule" />
          <div className="valor-col"><div className="valor-n">03</div><div className="valor-t">Melhora a execução</div><div className="valor-d">Mais consistência no dia a dia. Visibilidade real sobre o que acontece no negócio.</div></div>
          <div className="valor-col-rule" />
          <div className="valor-col"><div className="valor-n">04</div><div className="valor-t">Prepara para escalar</div><div className="valor-d">Uma base melhor para crescer sem perder controle. O produto evolui sem recomeçar do zero.</div></div>
        </div>
      </section>

      <div className="produto-sec" id="produtos">
        <div className="prod-left">
          <div className="prod-badge">Em validação agora</div>
          <h2 className="prod-h">THH GO</h2>
          <p className="prod-sub">O núcleo operacional da plataforma. Centraliza agendamento, histórico de clientes, automação via WhatsApp e avaliação pós-atendimento para tornar a operação mais eficiente e manter o foco no cliente.</p>
          <div className="prod-feats">
            <div className="feat"><span className="feat-dot" />Agendamento público sem atrito</div>
            <div className="feat"><span className="feat-dot" />Histórico de clientes e relacionamento</div>
            <div className="feat"><span className="feat-dot" />Automação de agendamento via WhatsApp</div>
            <div className="feat"><span className="feat-dot" />Avaliação pós-atendimento</div>
          </div>
          <a href="/go" className="btn-prod">Ver THH GO →</a>
        </div>
        <div className="prod-right">
          <div className="dark-app">
            <div className="dark-bar">
              <div className="dark-dot" style={{ background: "#ff5f57" }} />
              <div className="dark-dot" style={{ background: "#febc2e" }} />
              <div className="dark-dot" style={{ background: "#28c840" }} />
            </div>
            <div className="dark-body">
              <div className="dk-appt a"><div className="dk-nm">Mariana Costa</div><div className="dk-inf">09:00 · Corte + escova · R$ 120</div></div>
              <div className="dk-appt b"><div className="dk-nm">Juliana Ramos</div><div className="dk-inf">10:30 · Coloração · R$ 220</div></div>
              <div className="dk-appt c"><div className="dk-nm">Fernanda Lima</div><div className="dk-inf">12:00 · Hidratação · R$ 90</div></div>
              <div className="dk-stats">
                <div className="dk-s"><div className="dk-sv">R$920</div><div className="dk-sl">Receita hoje</div></div>
                <div className="dk-s"><div className="dk-sv">8</div><div className="dk-sl">Atendimentos</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="sec" id="verticais">
        <div className="sec-kicker">Verticais</div>
        <h2 className="sec-h">Começamos por Beauty.<br />Construímos para evoluir.</h2>
        <p className="sec-sub">Uma base única. Experiências especializadas por vertical. Expansão com consistência, sem refazer o que já funciona.</p>
        <div className="vert-layout">
          <div className="vert-item lead">
            <div className="vert-n">01</div>
            <div>
              <div className="vert-tag tag-live">Entrada</div>
              <div className="vert-name">Beauty</div>
              <div className="vert-desc">Salões, ateliês e profissionais autônomos de beleza. Vertical de entrada da THH, com produto em validação controlada.</div>
            </div>
          </div>
          <div className="vert-item">
            <div className="vert-n">02</div>
            <div>
              <div className="vert-tag tag-soon">Em breve</div>
              <div className="vert-name">Health</div>
              <div className="vert-desc">Clínicas, consultórios e profissionais de saúde. Suportada na arquitetura, entrada controlada.</div>
            </div>
          </div>
          <div className="vert-item">
            <div className="vert-n">03</div>
            <div>
              <div className="vert-tag tag-soon">Em breve</div>
              <div className="vert-name">Legal</div>
              <div className="vert-desc">Escritórios e profissionais jurídicos com atendimento recorrente e gestão por agenda.</div>
            </div>
          </div>
          <div className="vert-item">
            <div className="vert-n">04</div>
            <div>
              <div className="vert-tag tag-plan">Planejada</div>
              <div className="vert-name">Oficinas</div>
              <div className="vert-desc">Negócios de manutenção e serviços técnicos com recorrência, orçamentos e agendamento.</div>
            </div>
          </div>
        </div>
      </section>

      <div className="empresa-sec" id="empresa">
        <div className="empresa-grid">
          <div className="empresa-left">
            <div className="sec-kicker">Empresa</div>
            <p className="pull-quote">Uma <em>software company</em> focada em gestão operacional inteligente.</p>
            <p className="body-text">A THH cria tecnologia para transformar a complexidade do dia a dia em operação simples, eficiente e preparada para crescer. Não somos uma agenda. Não somos um ERP.</p>
            <p className="body-text">Somos uma plataforma de gestão operacional com histórico de clientes, automações úteis e avaliação pós-atendimento — desenhada para negócios baseados em atendimento, relacionamento e recorrência.</p>
          </div>
          <div className="empresa-rule" />
          <div className="empresa-right">
            <div className="emp-stats">
              <div className="emp-s"><div className="emp-num">01<span>.</span></div><div className="emp-lbl">Vertical de entrada com validação controlada</div></div>
              <div className="emp-s"><div className="emp-num">04<span>.</span></div><div className="emp-lbl">Verticais mapeadas para expansão progressiva</div></div>
              <div className="emp-s"><div className="emp-num">∞<span>.</span></div><div className="emp-lbl">Base única que escala sem refazer a arquitetura</div></div>
              <div className="emp-s"><div className="emp-num">0<span>.</span></div><div className="emp-lbl">Complexidade desnecessária entregue ao usuário</div></div>
            </div>
          </div>
        </div>
      </div>

      <section className="sec cultura-sec" id="cultura">
        <div className="sec-kicker">Cultura</div>
        <h2 className="sec-h">Clareza, responsabilidade<br />e execução.</h2>
        <p className="sec-sub">Construímos a THH com foco em responsabilidade técnica, simplicidade operacional e evolução contínua.</p>
        <div className="cultura-list">
          <div className="cultura-row">
            <span className="c-idx">01 —</span>
            <div className="c-title">Valor percebido primeiro</div>
            <div className="c-desc">Entregamos o que resolve antes de expandir. Funcionalidade sem valor percebido real não entra no produto.</div>
          </div>
          <div className="cultura-row">
            <span className="c-idx">02 —</span>
            <div className="c-title">Simplicidade operacional</div>
            <div className="c-desc">Complexidade interna, experiência simples. O produto absorve a dureza para que o usuário não precise lidar com ela.</div>
          </div>
          <div className="cultura-row">
            <span className="c-idx">03 —</span>
            <div className="c-title">Evolução progressiva</div>
            <div className="c-desc">Crescemos em etapas com critério. Não existe produto futuro sem produto presente que funcione de verdade.</div>
          </div>
        </div>
      </section>

      <div className="cta-sec">
        <div>
          <h2 className="cta-h">Pronto para organizar<br />sua <em>operação?</em></h2>
          <p className="cta-sub">Comece com o THH GO e veja o que acontece quando agenda, clientes e rotina de atendimento trabalham juntos.</p>
        </div>
        <div className="cta-actions">
          <a href="/go" className="btn-cta-main">Conheça o THH GO</a>
          <a href="/go/start" className="btn-cta-ghost">Fale com a THH →</a>
        </div>
      </div>

      <Footer brand="THH" message="THH — Software operacional para negócios que crescem" />
    </>
  );
}
